import { AxiosProgressEvent } from 'axios';

/** Normalize axios upload progress so the UI always receives a usable 1–100 value. */
export function reportUploadProgress(
  event: AxiosProgressEvent,
  onUploadProgress?: (percent: number) => void,
): void {
  if (!onUploadProgress) return;

  if (event.total && event.total > 0) {
    onUploadProgress(Math.min(100, Math.max(1, Math.round((event.loaded * 100) / event.total))));
    return;
  }

  if (event.loaded > 0) {
    onUploadProgress(Math.min(95, Math.max(1, Math.round(event.loaded / 100000))));
    return;
  }

  onUploadProgress(1);
}
